import { Component, Input, OnInit } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-vault-detail-widget',
    templateUrl: './vault-detail-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './vault-detail-widget.component.scss'],
    standalone: false
})
export class VaultDetailWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Input() vaultName: string;

  public title: string = 'Model Vault';

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.vaultName) {
      this.title = `Model Detail: ${this.vaultName}`;
    }
  }
}
